import { createAuth } from '@websanova/vue-auth'
import type { App } from 'vue'
import driverAuth from '@/plugins/driverAuth'
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm'
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm'
import { STORAGE_KEYS } from '@/constants/storageKeys'
import { redirectToAuth } from '@/utils/authRedirect'

export default (app: App) => {
	const authConfig = {
		rememberkey: STORAGE_KEYS.AUTH_REMEMBER,
		tokenDefaultKey: STORAGE_KEYS.AUTH_TOKEN,
		tokenImpersonateKey: STORAGE_KEYS.AUTH_TOKEN_IMPERSONATE,
		stores: ['storage', 'cookie'],
		plugins: { http: app.axios, router: app.router },
		drivers: { auth: driverAuth, http: driverHttpAxios, router: driverRouterVueRouter },
		options: {
			rolesKey: 'role',
			notFoundRedirect: { name: 'home' },
			loginData: { enabled: false },
			fetchData: { enabled: false },
			refreshData: { enabled: false },
			authRedirect: () => {
				redirectToAuth()
			},
			forbiddenRedirect: null
		}
	}
	app.use(createAuth(authConfig))
}
